import { getStepDotClass } from "@/lib/ui-helpers";

export default function StepProgress({ steps, current }) {
  return (
    <div className="hidden sm:flex items-center gap-2">
      {steps.map((n) => (
        <div
          key={n}
          className={`h-1.5 rounded-full transition-all ${getStepDotClass(n, current)}`}
        />
      ))}
    </div>
  );
}
